import { Button, Result, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

import styles from './style.module.less';

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Space align="center" className={styles[`not-found__space`]}>
      <Result
        status="404"
        title="404"
        subTitle="Desculpe, a pagina que você visitou não existe."
        extra={
          <Button type="primary" onClick={() => navigate(`/`)}>
            Voltar para início
          </Button>
        }
      />
    </Space>
  );
};
